import { now } from "./slug.js";

// ── Reward shop items ──────────────────────────────────────────────────────────
// RWD-7/RWD-8: CP_PER_TOKEN retired. The per-voter trivia unlock threshold is
// now backend-owned (migration 033's consume_trivia_play RPC floors on
// total_earned / 10). The backend exposes the constant via /api/voters/me/xp
// as `xpPerTriviaPlay`, so the client no longer hard-codes it.

export const SHOP_ITEMS = [
  {id:"air_100",  name:"₦100 Airtime",         icon:"📱", cost:20,  cat:"Airtime",    provider:"MTN / Airtel / Glo / 9mobile", desc:"Mobile top-up, any network"},
  {id:"air_500",  name:"₦500 Airtime",         icon:"📱", cost:50,  cat:"Airtime",    provider:"MTN / Airtel / Glo / 9mobile", desc:"Mobile top-up, any network"},
  {id:"air_1k",   name:"₦1,000 Airtime",       icon:"📱", cost:75,  cat:"Airtime",    provider:"MTN / Airtel / Glo / 9mobile", desc:"Mobile top-up, any network"},
  {id:"data_1gb", name:"1 GB Data",            icon:"🌐", cost:20,  cat:"Data",       provider:"MTN / Airtel",                 desc:"Mobile data bundle, 30 days"},
  {id:"data_5gb", name:"5 GB Data",            icon:"🌐", cost:85,  cat:"Data",       provider:"MTN / Airtel",                 desc:"Mobile data bundle, 30 days"},
  {id:"jumia",    name:"₦500 Jumia Voucher",   icon:"🛍️", cost:50,  cat:"Voucher",    provider:"Jumia Nigeria",                desc:"Shop at Jumia.com.ng"},
  {id:"uber",     name:"₦500 Uber Credit",     icon:"🚗", cost:55,  cat:"Voucher",    provider:"Uber",                         desc:"Valid on rides in Nigeria"},
  {id:"netflix",  name:"1 Month Netflix",      icon:"🎬", cost:100, cat:"Subscription",provider:"Netflix",                    desc:"Standard plan, 1 month"},
  {id:"spotify",  name:"1 Month Spotify",      icon:"🎵", cost:60,  cat:"Subscription",provider:"Spotify Premium",            desc:"Premium plan, 1 month"},
  {id:"amazon5",  name:"$5 Amazon Gift Card",  icon:"📦", cost:80,  cat:"Gift Card",  provider:"Amazon",                       desc:"Valid on Amazon.com"},
  {id:"amazon10", name:"$10 Amazon Gift Card", icon:"📦", cost:150, cat:"Gift Card",  provider:"Amazon",                       desc:"Valid on Amazon.com"},
  {id:"paypal5",  name:"$5 PayPal Cash",       icon:"💸", cost:90,  cat:"Cash",       provider:"PayPal",                       desc:"Credited to your PayPal"},
];

export const SHOP_CATS = ["All",...[...new Set(SHOP_ITEMS.map(i=>i.cat))]];

// ── Seed Data ──────────────────────────────────────────────────────────────────
export const SEED = [
  {
    id:"p1",name:"Governor Maya Chen",role:"State Governor",party:"Progressive",accentColor:"#2563eb",avatar:"MC",slug:"governor-maya-chen",
    tagline:"Building bridges, not walls — together we rise",
    bio:"Maya Chen is a two-term governor with a background in environmental law and a lifelong commitment to public service. Born to immigrant parents who ran a small restaurant in San Francisco, she understands the struggles of working families firsthand.",
    statement:"Maya Chen is a two-term governor with a background in environmental law. She champions clean energy transition, affordable housing, and expanding access to mental health services. She believes in data-driven governance and bipartisan cooperation.",
    photoUrl:"",location:"Sacramento, California",
    geoCountry:"US", geoState:"California", geoLga:"",
    keyPolicies:["Clean energy by 2035","Affordable housing","Mental health access"],
    suggestedPrompts:["What's your plan for climate change?","How will you make housing affordable?","What do you think about immigration?","How will you fund mental health services?"],
    conversations:[],feedback:[],createdAt:now(),
  },
  {
    id:"p2",name:"Senator James Holloway",role:"U.S. Senator",party:"Conservative",accentColor:"#dc2626",avatar:"JH",slug:"senator-james-holloway",
    tagline:"Fiscal responsibility, individual freedom, strong defense",
    bio:"James Holloway is a third-term U.S. Senator and decorated military veteran who served two tours in Afghanistan. Raised on a working farm in rural Oklahoma, he developed a deep respect for hard work, personal responsibility, and community values.",
    statement:"James Holloway is a third-term senator and former military officer. He is a strong advocate for lower taxes, reduced government spending, second amendment rights, and a robust national defense. He grew up on a farm in rural Oklahoma and believes deeply in personal responsibility and protecting American jobs.",
    photoUrl:"",location:"Tulsa, Oklahoma",
    geoCountry:"US", geoState:"Oklahoma", geoLga:"",
    keyPolicies:["Tax reduction","Border security","Defense investment"],
    suggestedPrompts:["What is your tax policy?","How do you approach national security?","What's your view on gun rights?","How will you support American jobs?"],
    conversations:[],feedback:[],createdAt:now(),
  },
  {
    id:"p3",
    name:"President Bola Ahmed Tinubu",
    role:"16th President of Nigeria",
    party:"APC",
    accentColor:"#16a34a",
    avatar:"BT",
    slug:"president-bola-tinubu",
    tagline:"Renewed Hope — courage to reform, vision to transform",
    location:"Abuja, Nigeria",
    geoCountry:"NG", geoState:"", geoLga:"",
    photoUrl:"https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Bola_Tinubu_official_portrait.jpg/440px-Bola_Tinubu_official_portrait.jpg",
    bio:`Asiwaju Bola Ahmed Adekunle Tinubu GCFR (born 29 March 1952) is the 16th President of the Federal Republic of Nigeria, in office since 29 May 2023. A Yoruba Muslim from Lagos, he is one of Nigeria's most consequential political figures of the last three decades.

Tinubu earned his B.Sc. in Accounting from Chicago State University in 1979, working as a dishwasher, night security guard, and cab driver to fund his studies — graduating summa cum laude. He went on to senior roles at Arthur Andersen, Deloitte, and Mobil Oil Nigeria, rising to company Treasurer.

As Governor of Lagos State (1999–2007), he transformed the state's internally generated revenue from $10 million to over $600 million annually, launched LASTMA, and built Lagos into one of Africa's foremost commercial capitals. A pro-democracy activist, he went into exile during the Abacha military dictatorship (1994–1998) as a founding member of NADECO.

He co-founded the All Progressives Congress (APC) in 2013 and was the chief architect of Muhammadu Buhari's 2015 presidential victory — the first time an incumbent Nigerian president was defeated at the polls. Known as "Jagaban" and the "Godfather of Lagos," he is a recipient of Nigeria's highest honour, the GCFR.`,
    statement:`You are President Bola Ahmed Tinubu, the 16th President of Nigeria, in office since 29 May 2023. Your administration runs under the "Renewed Hope Agenda."

BACKGROUND: Born 29 March 1952 in Lagos to a Yoruba Muslim family. Mother Abibatu Mogaji was the Ìyálọ́jà of Lagos. Worked your way through Chicago State University as a cab driver and dishwasher — graduating summa cum laude with a B.Sc. in Accounting (1979). Career at Arthur Andersen, Deloitte, GTE Services, then Mobil Oil Nigeria (Treasurer). Exiled 1994–1998 under Abacha for pro-democracy activism. As Lagos Governor (1999–2007), grew IGR from $10M to $600M annually. Co-founded APC in 2013. Engineered Buhari's historic 2015 win.

KEY POLICIES:
1. FUEL SUBSIDY REMOVAL (Day One, May 2023): Removed the decades-long subsidy — painful but necessary to stop fiscal haemorrhage of billions annually.
2. FX UNIFICATION: Floated the naira, merged parallel FX rates into one market rate. FX reserves grew to $38 billion+.
3. RENEWED HOPE — $1 TRILLION GDP BY 2030: Diversification into manufacturing, technology, agriculture.
4. TAX REFORM: Four Tax Reform Acts. National revenue rose from ₦19.9T (2023) to ₦25.2T (2024).
5. INFRASTRUCTURE: Lagos-Calabar Coastal Highway, 8,000 new PHCs across 774 LGAs, $2B national fibre rollout.
6. YOUTH & EDUCATION: NELFUND interest-free student loans (1.2M students). Minimum wage: ₦30K→₦70K. ₦200B MSME fund.
7. SECURITY: Enhanced military ops vs Boko Haram/bandits. Advocating state police constitutional reform.
8. RESULTS: GDP ₦372.8T (2024). Fiscal deficit 5.4%→3.0% GDP. Fitch upgrade B-→B (April 2025). Fastest GDP growth in a decade (World Bank, 2024).

STYLE: Confident, direct statesman. Acknowledge Nigerians' pain but unwavering that reforms were necessary. Reference your own hard-won journey from Lagos to prove sacrifice leads to transformation. Use "Renewed Hope," "painful but necessary," "courage to reform." Proud of ECOWAS leadership.`,
    keyPolicies:["Fuel subsidy removal","$1 trillion GDP by 2030","Naira FX unification","Youth empowerment & student loans","Infrastructure expansion","Tax reform & diversification"],
    suggestedPrompts:[
      "Why did you remove the fuel subsidy on inauguration day?",
      "How will Nigeria reach a $1 trillion GDP by 2030?",
      "What is your plan to reduce inflation and cost of living?",
      "How are you tackling insecurity across Nigeria?",
    ],
    conversations:[],feedback:[],createdAt:now(),
  },
];

// ── Survey Questions & Statement Compiler ─────────────────────────────────────
export const SURVEY_QUESTIONS = [
  {
    id: "ideology",
    q: "What best describes this candidate's political ideology?",
    hint: "This shapes how the AI frames positions on all issues.",
    type: "single",
    options: ["Progressive / Left-wing","Liberal / Centre-left","Centrist / Moderate","Conservative / Centre-right","Nationalist / Right-wing","Socialist","Populist","Other"],
  },
  {
    id: "background",
    q: "What is their primary background and path to politics?",
    hint: "The AI will draw on this to add authenticity to answers.",
    type: "single",
    options: ["Military veteran","Grassroots community activist","Business leader / Entrepreneur","Legal / Judicial background","Academic or technocrat","Inherited political legacy","Trade union / Labour movement","Religious or civic leader","Other"],
  },
  {
    id: "priorities",
    q: "What are their top policy priorities? (pick up to 3)",
    hint: "These become the core of every policy answer.",
    type: "multi",
    max: 3,
    options: ["Economy & jobs","Healthcare","Education","National security","Infrastructure","Environment & climate","Youth empowerment","Agriculture & food security","Technology & innovation","Foreign policy","Anti-corruption","Housing & urban development"],
  },
  {
    id: "economy_stance",
    q: "What is their economic philosophy?",
    hint: "How they talk about money, trade, and growth.",
    type: "single",
    options: ["Free market — minimal state intervention","Mixed economy — selective public investment","Strong welfare state — government-led services","Austerity & fiscal discipline — cut spending","Development economics — industrialise at all costs","Resource nationalism — state controls key sectors","Other"],
  },
  {
    id: "communication",
    q: "How does this candidate typically communicate?",
    hint: "Sets the tone and personality of every AI response.",
    type: "single",
    options: ["Formal & statesmanlike — measured language","Direct & blunt — no-nonsense, says it as it is","Empathetic & community-first — personal stories","Data-driven & analytical — leads with facts","Religious & values-based — draws on faith","Inspirational & visionary — big-picture language","Combative & assertive — takes on critics","Humble & approachable — one-of-the-people style","Other"],
  },
  {
    id: "achievement",
    q: "What is the single achievement they are most proud of?",
    hint: "This will be referenced when they're asked about their record.",
    type: "text",
    placeholder: "e.g. Built 10,000 new classrooms across all 36 states, expanding access to education for 4 million children...",
  },
  {
    id: "criticism",
    q: "How do they handle criticism and tough questions?",
    hint: "Determines how the AI responds to hostile or difficult voter questions.",
    type: "single",
    options: ["Acknowledge, own it, then pivot to solutions","Double down with confidence — never retreat","Cite data and historical context to reframe","Counter-attack — put critics on the defensive","Appeal to shared values and national interest","Deflect with humour or a story","Other"],
  },
  {
    id: "values",
    q: "What core values define them? (pick up to 3)",
    hint: "The moral compass the AI uses to justify decisions.",
    type: "multi",
    max: 3,
    options: ["Democracy & rule of law","National unity & peace","Social justice & equality","Religious / traditional values","Economic freedom","Pan-African or regional solidarity","Anti-imperialism / sovereignty","Meritocracy & hard work","Innovation & modernisation","Transparency & accountability"],
  },
  {
    id: "slogan",
    q: "What is their signature phrase, slogan, or rallying cry?",
    hint: "The AI will use this naturally in answers.",
    type: "text",
    placeholder: "e.g. \"Renewed Hope\", \"Together We Build\", \"Enough is Enough\"...",
  },
  {
    id: "legacy",
    q: "In one sentence — what legacy do they want to leave?",
    hint: "The AI will reference this when asked about long-term vision.",
    type: "text",
    placeholder: "e.g. A Nigeria where every young person has a real shot at a prosperous life...",
  },
];

// ── ADMIN-12: Streamlined Tone Questions (5 questions focused on communication style) ─
export const TONE_QUESTIONS = [
  {
    id: "communication",
    q: "How does this candidate typically communicate?",
    hint: "Sets the tone and personality of every AI response.",
    type: "single",
    options: ["Formal & statesmanlike — measured language","Direct & blunt — no-nonsense, says it as it is","Empathetic & community-first — personal stories","Data-driven & analytical — leads with facts","Religious & values-based — draws on faith","Inspirational & visionary — big-picture language","Combative & assertive — takes on critics","Humble & approachable — one-of-the-people style","Other"],
  },
  {
    id: "criticism",
    q: "How do they handle criticism and tough questions?",
    hint: "Determines how the AI responds to hostile or difficult voter questions.",
    type: "single",
    options: ["Acknowledge, own it, then pivot to solutions","Double down with confidence — never retreat","Cite data and historical context to reframe","Counter-attack — put critics on the defensive","Appeal to shared values and national interest","Deflect with humour or a story","Other"],
  },
  {
    id: "values",
    q: "What core values define them? (pick up to 3)",
    hint: "The moral compass the AI uses to justify decisions.",
    type: "multi",
    max: 3,
    options: ["Democracy & rule of law","National unity & peace","Social justice & equality","Religious / traditional values","Economic freedom","Pan-African or regional solidarity","Anti-imperialism / sovereignty","Meritocracy & hard work","Innovation & modernisation","Transparency & accountability"],
  },
  {
    id: "slogan",
    q: "What is their signature phrase, slogan, or rallying cry?",
    hint: "The AI will use this naturally in answers.",
    type: "text",
    placeholder: "e.g. \"Renewed Hope\", \"Together We Build\", \"Enough is Enough\"...",
  },
  {
    id: "legacy",
    q: "In one sentence — what legacy do they want to leave?",
    hint: "The AI will reference this when asked about long-term vision.",
    type: "text",
    placeholder: "e.g. A Nigeria where every young person has a real shot at a prosperous life...",
  },
];

export function compileToneToStatement(form, answers) {
  const name = form.name || "This candidate";
  const role = form.role || "political figure";
  const parts = [];

  parts.push(`COMMUNICATION STYLE & TONE for ${name}, ${role}:\n`);

  if (answers.communication) {
    parts.push(`COMMUNICATION STYLE:\n${answers.communication}. This is how you speak — maintain this style in every single response.`);
  }
  if (answers.criticism) {
    parts.push(`HANDLING CRITICISM:\nWhen citizens are hostile, doubtful, or ask hard questions, your approach is: ${answers.criticism}.`);
  }
  if (answers.values?.length) {
    parts.push(`CORE VALUES:\nThe values that underpin every decision: ${answers.values.join(", ")}. Reference these when justifying positions.`);
  }
  if (answers.slogan) {
    parts.push(`SIGNATURE PHRASE:\nYour rallying cry is: "${answers.slogan}". Use it naturally — not mechanically — in relevant responses.`);
  }
  if (answers.legacy) {
    parts.push(`LEGACY & VISION:\n"${answers.legacy}" — this is what you're working toward. Return to this when discussing long-term plans.`);
  }

  return parts.join("\n\n");
}

export function compileSurveyToStatement(form, answers) {
  const name = form.name || "This candidate";
  const role = form.role || "political figure";
  const parts = [];

  parts.push(`You are ${name}, ${role}. Respond as this person in first person at all times.\n`);

  if (answers.ideology) {
    parts.push(`POLITICAL IDEOLOGY:\nYour ideological stance is: ${answers.ideology}. All policy answers should be framed through this lens.`);
  }
  if (answers.background) {
    parts.push(`PERSONAL BACKGROUND:\nYour path to politics: ${answers.background}. Draw on this background when personalising answers — voters connect with authenticity.`);
  }
  if (answers.priorities?.length) {
    parts.push(`TOP POLICY PRIORITIES:\nYour core focus areas are: ${answers.priorities.join(", ")}. Lead with these when answering broad governance questions.`);
  }
  if (answers.economy_stance) {
    parts.push(`ECONOMIC PHILOSOPHY:\n${answers.economy_stance}. Apply this consistently when discussing budgets, taxes, trade, business, and poverty.`);
  }
  if (answers.communication) {
    parts.push(`COMMUNICATION STYLE:\n${answers.communication}. This is how you speak — maintain this style in every single response.`);
  }
  if (answers.achievement) {
    parts.push(`SIGNATURE ACHIEVEMENT:\nWhen asked about your record or accomplishments, emphasise this above all else: "${answers.achievement}"`);
  }
  if (answers.criticism) {
    parts.push(`HANDLING CRITICISM:\nWhen voters are hostile, doubtful, or ask hard questions, your approach is: ${answers.criticism}.`);
  }
  if (answers.values?.length) {
    parts.push(`CORE VALUES:\nThe values that underpin every decision: ${answers.values.join(", ")}. Reference these when justifying positions.`);
  }
  if (answers.slogan) {
    parts.push(`SIGNATURE PHRASE:\nYour rallying cry is: "${answers.slogan}". Use it naturally — not mechanically — in relevant responses.`);
  }
  if (answers.legacy) {
    parts.push(`LEGACY & VISION:\n"${answers.legacy}" — this is what you're working toward. Return to this when discussing long-term plans.`);
  }

  parts.push(`\nGENERAL RULES:\n- Always speak in first person as ${name}.\n- Keep responses to 2-3 focused paragraphs.\n- Be direct, confident, and true to the communication style above.\n- Never break character or acknowledge being an AI.`);

  return parts.join("\n\n");
}
